/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteFenceResult } from '../fn/fence-results/delete-fence-result';
import { DeleteFenceResult$Params } from '../fn/fence-results/delete-fence-result';
import { deleteFenceResultByGuid } from '../fn/fence-results/delete-fence-result-by-guid';
import { DeleteFenceResultByGuid$Params } from '../fn/fence-results/delete-fence-result-by-guid';
import { FenceResult } from '../models/fence-result';
import { fenceResultPost } from '../fn/fence-results/fence-result-post';
import { FenceResultPost$Params } from '../fn/fence-results/fence-result-post';
import { fenceResultsLatestGeneration } from '../fn/fence-results/fence-results-latest-generation';
import { FenceResultsLatestGeneration$Params } from '../fn/fence-results/fence-results-latest-generation';
import { fenceResultsOnlyReportable } from '../fn/fence-results/fence-results-only-reportable';
import { FenceResultsOnlyReportable$Params } from '../fn/fence-results/fence-results-only-reportable';

@Injectable({ providedIn: 'root' })
export class FenceResultsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `fenceResultsOnlyReportable()` */
  static readonly FenceResultsOnlyReportablePath = '/races/{raceGuid}/onlyreportable/{onlyReportable}/fenceresults';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fenceResultsOnlyReportable()` instead.
   *
   * This method doesn't expect any request body.
   */
  fenceResultsOnlyReportable$Response(params: FenceResultsOnlyReportable$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FenceResult>>> {
    const obs = fenceResultsOnlyReportable(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fenceResultsOnlyReportable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fenceResultsOnlyReportable(params: FenceResultsOnlyReportable$Params, context?: HttpContext): Observable<Array<FenceResult>> {
    const resp = this.fenceResultsOnlyReportable$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FenceResult>>): Array<FenceResult> => r.body)
    );
  }

  /** Path part for operation `fenceResultsLatestGeneration()` */
  static readonly FenceResultsLatestGenerationPath = '/races/{raceGuid}/onlyreportable/{onlyReportable}/fenceresults/latest-generation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fenceResultsLatestGeneration()` instead.
   *
   * This method doesn't expect any request body.
   */
  fenceResultsLatestGeneration$Response(params: FenceResultsLatestGeneration$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FenceResult>>> {
    const obs = fenceResultsLatestGeneration(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fenceResultsLatestGeneration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  fenceResultsLatestGeneration(params: FenceResultsLatestGeneration$Params, context?: HttpContext): Observable<Array<FenceResult>> {
    const resp = this.fenceResultsLatestGeneration$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FenceResult>>): Array<FenceResult> => r.body)
    );
  }

  /** Path part for operation `fenceResultPost()` */
  static readonly FenceResultPostPath = '/races/{raceGuid}/fenceresults';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `fenceResultPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fenceResultPost$Response(params: FenceResultPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = fenceResultPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `fenceResultPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  fenceResultPost(params: FenceResultPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.fenceResultPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteFenceResult()` */
  static readonly DeleteFenceResultPath = '/races/{raceGuid}/horsecombinations/{horseCombinationNumber}/riders/fenceresults';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFenceResult()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFenceResult$Response(params: DeleteFenceResult$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteFenceResult(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFenceResult$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFenceResult(params: DeleteFenceResult$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteFenceResult$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteFenceResultByGuid()` */
  static readonly DeleteFenceResultByGuidPath = '/races/{raceGuid}/riders/{riderGuid}/fenceresults';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFenceResultByGuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFenceResultByGuid$Response(params: DeleteFenceResultByGuid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteFenceResultByGuid(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFenceResultByGuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFenceResultByGuid(params: DeleteFenceResultByGuid$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteFenceResultByGuid$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
